import { useState } from "react";
import { Box, Text, Stack, HStack, Image, Wrap, WrapItem, Button } from "@chakra-ui/react";
import { useLanguage } from "../context/LanguageContext";
import { useStudies, useCategories, pick } from "../hooks/useContent";
import { studyCategories } from "../admin/collectionsConfig";
import { formatDateRange } from "../utils/dateRange";
import { ListCardsSkeleton } from "./ui/Skeletons";
import Section from "./ui/Section";

function Studies() {
  const { language } = useLanguage();
  const { data: studies = [], loading } = useStudies();
  const { data: dbCats } = useCategories("studies");
  const [filter, setFilter] = useState("all");

  const eyebrow = language === "es" ? "FORMACIÓN" : "EDUCATION";
  const title = language === "es" ? "Estudios" : "Education";
  const catLabel = (c) => (language === "es" ? c.label_es : c.label_en);
  const categories = dbCats.length ? dbCats : studyCategories;
  const presentCategories = categories.filter((c) =>
    studies.some((s) => s.category === c.value)
  );
  const filtered =
    filter === "all" ? studies : studies.filter((s) => s.category === filter);

  if (loading) {
    return (
      <Section id="studies" eyebrow={eyebrow} title={title}>
        <ListCardsSkeleton count={2} />
      </Section>
    );
  }

  return (
    <Section id="studies" eyebrow={eyebrow} title={title}>
      {presentCategories.length > 0 && (
        <Wrap spacing={2} mb={6}>
          <WrapItem>
            <Button
              size="sm"
              variant={filter === "all" ? "solid" : "outline"}
              colorScheme="blue"
              onClick={() => setFilter("all")}
            >
              {language === "es" ? "Todos" : "All"}
            </Button>
          </WrapItem>
          {presentCategories.map((c) => (
            <WrapItem key={c.value}>
              <Button
                size="sm"
                variant={filter === c.value ? "solid" : "outline"}
                colorScheme="blue"
                onClick={() => setFilter(c.value)}
              >
                {catLabel(c)}
              </Button>
            </WrapItem>
          ))}
        </Wrap>
      )}
      <Stack spacing={4}>
        {filtered.map((s) => (
          <Box
            key={s.id}
            bg="bg.card"
            border="1px solid"
            borderColor="border.card"
            borderLeft="4px solid"
            borderLeftColor="brand.400"
            borderRadius="xl"
            p={6}
          >
            <HStack spacing={3} align="center">
              {s.image_url && (
                <Image
                  src={s.image_url}
                  alt={s.institution}
                  boxSize="44px"
                  objectFit="contain"
                  borderRadius="md"
                  bg="white"
                  p={1}
                  flexShrink={0}
                />
              )}
              <Box>
                <Text fontWeight="bold" fontSize="lg" color="text.heading">
                  {pick("title", s, language)}
                </Text>
                <Text color="text.muted" fontSize="sm">
                  {s.institution}
                </Text>
              </Box>
            </HStack>
            <Text color="brand.400" fontSize="sm" mt={1}>
              {formatDateRange(s.date_start, s.date_end, s.current, language)}
            </Text>
            <Text color="text.muted" mt={3} fontSize="sm">
              {pick("description", s, language)}
            </Text>
          </Box>
        ))}
      </Stack>
    </Section>
  );
}

export default Studies;
